export const faqs = [
  {
    q: "What are the check-in and check-out times?",
    a: "Check-in is from 1:00 PM to 2:00 PM and check-out is before 12:30 PM. Our 24-hour front desk can help if you arrive earlier or later — just call ahead.",
  },
  {
    q: "What types of rooms can I book?",
    a: "We offer Standard Double, Standard King, Triple and Suite rooms. Every room is air-conditioned with a flat-screen TV and a private bathroom.",
  },
  {
    q: "How much does a stay cost?",
    a: "Rooms generally range from ₹2,200 to ₹4,200 per night depending on the room category, dates and booking platform. Enter your dates on the booking page to see live prices.",
  },
  {
    q: "Is parking available?",
    a: "Yes. Free private parking is available for hotel guests and event visitors.",
  },
  {
    q: "Is Wi-Fi free?",
    a: "Yes, complimentary Wi-Fi is available throughout the property.",
  },
  {
    q: "Do you host weddings and corporate events?",
    a: "Yes. Hydepark Regency is also a convention center with meeting and banquet facilities for weddings, receptions, conferences and private celebrations. Contact us with your date and guest count for a custom plan.",
  },
  {
    q: "Where is the hotel located?",
    a: "We are on Manjakulam Road in Valakkad, Palakkad, opposite Manjakulam Mosque and within walking distance of the KSRTC bus stand, about 1.6 km from the city center.",
  },
  {
    q: "Do you offer room service?",
    a: "Yes, room service is available so you can enjoy meals and refreshments in your room.",
  },
];
